export const LONG_ACTION_CHARACTER_THRESHOLD = 160;

export const ACTION_WRITING_GUIDANCE = 'Actions work best when they describe one clear thing you can do next.';

export const LONG_ACTION_GUIDANCE = 'This action contains a lot of detail. Consider splitting it into smaller actions or moving supporting information into notes.';

export const isLongAction = (value) => String(value || '').length > LONG_ACTION_CHARACTER_THRESHOLD;
